import { Assignment, Close, PeopleOutline, SettingsOutlined } from "@mui/icons-material";
import { Box, Drawer, IconButton, List, ListItemButton, ListItemIcon, ListItemText, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useSalePermissions } from "./SalePermissionBoundary";
import { saleNavigation } from "@/lib/sale-navigation";

export default function SecondAppSidebar({ open, onClose }: { open: boolean; onClose: () => void }) {
  const { session, loading, error } = useSalePermissions();
  const location = useLocation();
  const navigate = useNavigate();
  const items = loading || error ? [] : saleNavigation(session || null);
  return <Drawer anchor="left" open={open} onClose={onClose}>
    <Box component="nav" aria-label="Sale Support" sx={{ width: 290, maxWidth: "85vw", p: 2 }}>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <Typography variant="h6">Sale Support</Typography>
        <IconButton aria-label="Close navigation" onClick={onClose}><Close /></IconButton>
      </Box>
      <List>{items.map(item => <ListItemButton key={item.code}
        selected={location.pathname === item.path || location.pathname.startsWith(`${item.path}/`)}
        onClick={() => { navigate(item.path); onClose(); }}>
        <ListItemIcon>{item.code === "sale_management" ? <Assignment /> : item.code === "global_configuration" ? <SettingsOutlined /> : <PeopleOutline />}</ListItemIcon>
        <ListItemText primary={item.name} />
      </ListItemButton>)}</List>
    </Box>
  </Drawer>;
}
